const filter   = require(`ramda/src/filter`);
const pipe     = require(`ramda/src/pipe`);
const omit     = require(`ramda/src/omit`);
const map      = require(`ramda/src/map`);
const assoc    = require(`ramda/src/assoc`);
const prop     = require(`ramda/src/prop`);
const dissoc   = require(`ramda/src/dissoc`);
const ifElse   = require(`ramda/src/ifElse`);
const path     = require(`ramda/src/path`);
const identity = require(`ramda/src/identity`);

function getDataOfType (dataType) {
    const isOfContentType = content => content.sys.contentType.sys.id === dataType;
    const trimSys         = content => omit([`sys`], content);

    return map(trimSys, filter(isOfContentType));
}

const mapData = (dataType, mapFn) => pipe(
    getDataOfType(dataType),
    map(
        pipe(
            prop(`fields`),
            mapFn
        )
    )
);

const setProps = (propName, _path, data) => {
    if (propName === `questionId` || propName === `nextQuestion`) {
        return assoc(propName, path(_path, data), data);
    } else {
        return assoc(propName, `https:${path(_path, data)}`, data);
    }
};

// Video

const setURLProp = data => setProps(`url`, [`video`, `fields`, `file`, `url`], data);

const getVideoURL = pipe(
    setURLProp,
    dissoc(`video`)
);

const scrubVideoData = mapData(
    `video`,
    ifElse(
        prop(`video`),
        getVideoURL,
        identity
    )
);

// Article

const getSrc = data => setProps(`src`, [`imageFile`, `fields`, `file`, `url`], data);

const scrubArticleData = mapData(
    `article`,
    pipe(
        getSrc,
        dissoc(`imageFile`)
    )
);

// Multiple Choice Questions

const getNextQuestion = data => setProps(`nextQuestion`, [`nextQuestion`, `fields`, `questionId`, `fields`, `questionId`], data);

const setOptions = data => {
    const cleanOptions = pipe(
        pipe(
            path([`options`]),
            map(
                prop(`fields`)
            )
        ),
        map(
            getNextQuestion
        )
    );

    return assoc(
        `options`,
        cleanOptions(data),
        data
    );
};

const setQuestionIdProp = data => setProps(`questionId`, [`questionId`, `fields`, `questionId`], data);

// TODO :: Scrub the data for the options array to only have the `fields` elements
const scrubQuestionsData = mapData(
    `multipleChoiceQuestion`,
    pipe(
        setQuestionIdProp,
        setOptions
    )
);

function getQuestionWithId (data, inputId) {
    const questionData = scrubQuestionsData(data);

    return questionData[Object.keys(questionData).find(key => {
        let question = questionData[key];

        return question.questionId === inputId;
    })];
}

export {getDataOfType, scrubVideoData, scrubArticleData, getQuestionWithId};
